export default __webpack_public_path__ + "static/media/rusgot-screenshot-04.3d1ef994.png";